import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5d55064e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-title"
}, [/*#__PURE__*/_createElementVNode("label", null, "产品服务")], -1));
const _hoisted_3 = {
  class: "product"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-title"
}, [/*#__PURE__*/_createElementVNode("label", null, "解决方案")], -1));
const _hoisted_5 = {
  class: "project"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-title"
}, [/*#__PURE__*/_createElementVNode("label", null, "新闻中心")], -1));
const _hoisted_7 = {
  class: "press"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-title"
}, [/*#__PURE__*/_createElementVNode("label", null, "关于我们")], -1));
const _hoisted_9 = {
  class: "us"
};
const _hoisted_10 = {
  class: "link-us"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "company-logo"
}, null, -1));
const _hoisted_12 = {
  class: "hot-link"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " 7*24小时客服热线：", -1));
const _hoisted_14 = {
  class: "tel"
};
const _hoisted_15 = {
  class: "code"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "code-name"
};
const _hoisted_18 = {
  class: "other-account"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy-right"
}, [/*#__PURE__*/_createElementVNode("label", null, [/*#__PURE__*/_createTextVNode(" Copyright©2023-2025, hdgyl.com.cn All Rights Reserved. "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/#/Integrated/index"
}, "津ICP备2023001685号-1"), /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019002003070"
}, "陕公网安备61019002003070号")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_divider = _resolveComponent("a-divider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.goLink('/freight'))
  }, "数字货运")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.goLink('/product'))
  }, "数字供应链")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[2] || (_cache[2] = $event => _ctx.goLink('/figureEnertgy'))
  }, "数字能源")])]), _hoisted_4, _createElementVNode("ul", _hoisted_5, [_createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.goLink('/coal'))
  }, "煤炭行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.goLink('/power'))
  }, "电力行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[5] || (_cache[5] = $event => _ctx.goLink('/chemical'))
  }, "化工行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[6] || (_cache[6] = $event => _ctx.goLink('/rail'))
  }, "铁路货站")])]), _hoisted_6, _createElementVNode("ul", _hoisted_7, [_createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.goLink('/companyNews'))
  }, "公司新闻")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[8] || (_cache[8] = $event => _ctx.goLink('/partyNews'))
  }, "党群建设")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[9] || (_cache[9] = $event => _ctx.goLink('/enterpriseNews'))
  }, "企业文化")])]), _hoisted_8, _createElementVNode("ul", _hoisted_9, [_createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[10] || (_cache[10] = $event => _ctx.goLink('/aboutHuoda'))
  }, "关于货达")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[11] || (_cache[11] = $event => _ctx.goLink('/joinUs'))
  }, "加入我们")])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_divider, {
    class: "divider"
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaSchema, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["wx-current-media", {
        active: item.type === _ctx.currentMedialName
      }])
    }, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("label", _hoisted_14, _toDisplayString(item.hotline), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
      src: item.imgPath
    }, null, 8, _hoisted_16)]), _createElementVNode("label", _hoisted_17, _toDisplayString(item.info), 1)], 2);
  }), 256)), _createElementVNode("div", _hoisted_18, [_createTextVNode(" 官方全媒体账号： "), _createElementVNode("label", null, [_createElementVNode("i", {
    class: _normalizeClass(["font_family icon-weixin", {
      'icon-active': _ctx.currentMedialName === 'wx'
    }]),
    onMouseenter: _cache[12] || (_cache[12] = $event => _ctx.mediaBlurHandle('wx'))
  }, null, 34), _createElementVNode("i", {
    class: _normalizeClass(["font_family icon-douyin", {
      'icon-active': _ctx.currentMedialName === 'dy'
    }]),
    onMouseenter: _cache[13] || (_cache[13] = $event => _ctx.mediaBlurHandle('dy'))
  }, null, 34), _createElementVNode("i", {
    class: _normalizeClass(["font_family icon-weixinshipin", {
      'icon-active': _ctx.currentMedialName === 'wxsp'
    }]),
    onMouseenter: _cache[14] || (_cache[14] = $event => _ctx.mediaBlurHandle('wxsp'))
  }, null, 34), _createElementVNode("i", {
    class: _normalizeClass(["font_family icon-kuaishou", {
      'icon-active': _ctx.currentMedialName === 'ks'
    }]),
    onMouseenter: _cache[15] || (_cache[15] = $event => _ctx.mediaBlurHandle('ks'))
  }, null, 34)])])]), _hoisted_19]);
}